// MenuItem Component
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface MenuItemProps {
    label: string;
    url: string;
    iconSrc: { disabled: string; enabled: string };
    onClick?: () => void; // Optional onClick handler
}

const MenuItem: React.FC<MenuItemProps> = ({ label, url, iconSrc, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation();

    const isActive = location.pathname === url;
    const iconToShow = isActive || isHovered ? iconSrc.enabled : iconSrc.disabled;

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <Link
            to={url}
            onClick={() => {
                if (onClick) onClick(); // Close the sidebar if onClick is passed
                scrollTop(); // Maintain scroll-to-top behavior
            }}
            className={`flex w-full items-center text-black ${
                isActive ? 'bg-bunker' : ''
            } hover:bg-light-bunker hover:text-black cursor-pointer rounded-lg`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <li className="flex items-center w-full px-4 py-2 truncate">
                <img className="h-5 w-5 mr-3 flex-shrink-0" src={iconToShow} alt={label} />
                <span className="text-sm truncate">{label}</span>
            </li>
        </Link>
    );
};

export default MenuItem;
